import React from 'react';
import {
  Filter,
  List,
  Edit,
  Create,
  SimpleForm,
  Datagrid,
  TextField,
  TextInput,
  NumberInput,
  EditButton,
  EmailField,
  NumberField,
  Responsive,
  SimpleList,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  downloadCSV
} from "react-admin";
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

export const GrandesGeneradoresesFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Nombre" source="searchnombre" autoFocus alwaysOn />
    </Filter>
  )
}

const exporter = data => {
    const csv = convertToCSV({
        data,
        fields: ['nombre', 'domicilio', 'telefono', 'email', 'cuit', 'vendedor', 'comprador' ],
    });
    downloadCSV(csv, 'ingreso-puerta-puerta'); // download as 'posts.csv` file
};

export const GrandesGeneradoresList = props => (
    <List
      {...props}
      bulkActions={false}
      filters={<GrandesGeneradoresesFilter />}
      exporter={exporter}
      sort={{ field: "nombre", order: "ASC" }}
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.nombre }
            secondaryText={record => record.email }
          />
        }
        medium={
          <Datagrid>
            <TextField source="nombre" />
            <TextField source="domicilio" />
            <TextField source="telefono" />
            <EmailField source="email" />
            <NumberField source="cuit" />
            <ReferenceField label="Etapas" reference="etapas-grandes-generadores" source="etapas">
              <TextField source="nombre" />
            </ReferenceField>
            <EditButton />
          </Datagrid>
        }
      />
    </List>
);

export const GrandesGeneradoresCreate = props => (
  <Create {...props} title="Incorporar Grandes Generadores">
    <SimpleForm redirect="/grandes-generadores">
      <TextInput label="Razon social" source="nombre" />
      <TextInput label="Domicilio" source="domicilio" />
      <TextInput label="Teléfono" source="telefono" />
      <TextInput label="Contacto" source="contacto" />
      <TextInput label="Teléfono del contacto" source="contactoTelefono" />
      <TextInput label="Email" source="email" />
      <NumberInput label="cuit" source="cuit" />
      <ReferenceInput reference="etapas-grandes-generadores" source="etapas">
        <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const GrandesGeneradoresEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect="/grandes-generadores">
          <TextInput label="Razon social" source="nombre" />
          <TextInput label="Domicilio" source="domicilio" />
          <TextInput label="Teléfono" source="telefono" />
          <TextInput label="Contacto" source="contacto" />
          <TextInput label="Teléfono del contacto" source="contactoTelefono" />
          <TextInput label="Email" source="email" />
          <NumberInput label="cuit" source="cuit" />
          <ReferenceInput reference="etapas-grandes-generadores" source="etapas">
            <SelectInput  optionText="nombre" optionValue="_id" fullWidth />
          </ReferenceInput>
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/services/grandesGeneradores.js